import classnames from 'classnames';
import React, { ReactElement, ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router';

import StepsService from '../../services/StepsService';
import styles from './StickyWrapper.module.scss';

interface StepsProps {
  children?: ReactNode;
  isSticky: boolean;
  setIsSticky: (isSticky: boolean) => void;
}

let previousScrollValue = 0;

const StickyWrapperComponent = ({ children, setIsSticky, isSticky }: StepsProps): ReactElement => {
  const { pathname } = useLocation();

  useEffect(() => {
    setIsSticky(false);
  }, [pathname, setIsSticky]);

  useEffect(() => {
    const onScroll = (event: Event): void => {
      const currentScrollValue = (event.target as Document)?.scrollingElement?.scrollTop || 0;
      const scrollTopMax = (event.target as Document)?.scrollingElement!.scrollHeight
        - (event.target as Document)?.scrollingElement!.clientHeight;

      if (currentScrollValue < 0 || currentScrollValue > scrollTopMax) {
        return;
      }

      if (currentScrollValue > previousScrollValue) {
        setIsSticky(true);
      } else if (currentScrollValue < previousScrollValue) {
        setIsSticky(false);
      }

      previousScrollValue = currentScrollValue;
    };

    window.addEventListener('scroll', onScroll);

    return (): void => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [setIsSticky]);

  const stepsClasses = classnames(
    styles.stickyWrapper,
    StepsService.showStepperBackground(pathname) && 'header-opacity-background',
    isSticky ? styles.hideHeader : styles.showHeader,
  );

  return (
    <div className={stepsClasses} id="sticky">
      {children}
    </div>
  );
};

export const StickyWrapper = React.memo(StickyWrapperComponent);
